exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".book-page{width:1170px;padding:0 0 30px;margin:0 auto}.book-page .page-title{width:100%;height:32px;line-height:32px;font-size:20px;color:#212121;text-align:center;margin:10px 0}.book-page .content-body{position:relative;min-height:500px;margin-top:25px;box-shadow:0 2px 8px 0 rgba(0,0,0,.1)}.book-page .content-box{width:100%;padding:22px 25px 25px 270px;box-sizing:border-box}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-37661900","scoped":false,"hasInlineConfig":false}!./node_modules/postcss-loader/lib!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/help/handbook.vue
// module id = 915
// module chunks = 0